import { Component, OnInit, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { $app } from "@app/app.service";

import { Subscription } from 'rxjs';

@Component({
    selector: 'entity-app-basic',
    template: ''
})
export class AppBasicEntity implements OnInit, AfterViewInit, OnDestroy {

    @Input() name: string = '';
    
    console: boolean = $app.core.modeDevel;
    logPrefix: string = '@entity - '+ this.constructor.name;

    $app = $app; //for use in template

    listener: Subscription;

    ngOnInit(): void {

        if(this.console) console.log( this.logPrefix, 'init');
    }

    ngAfterViewInit() {

    }

    ngOnDestroy() {

        if(this.listener) this.listener.unsubscribe();
    }

    initListener(){

        this.listener = new Subscription();
    }
}